
import Vue from 'vue'

export default Vue.extend({
   name: 'LinkDisplay',
   props: {
      label: String,
      value: [String, Boolean, Number],
      href: String,
      target: { type: String, default: '_blank' }
   },
})
